import { apiClient } from './axios-intercept';
import { DEFAULT_SERVER } from './conf';
import { Util } from './util';

const CLASS ="/api/v1/class";
const ELEARNING = "elearning";
const EXPORT ="/api/v1/class/export";
const PREVIEW_STUDENT = "/api/v1/preview/student";

export const EXPORT_CLASS_URL = DEFAULT_SERVER+EXPORT;
export const EXPORT_CLASS_TRAINER_URL = DEFAULT_SERVER+'/api/v1/page/trainer/class-pagination/export'
const SEARCH_CLASS_URL = DEFAULT_SERVER + CLASS;
const ADD_CLASS_URL = DEFAULT_SERVER + CLASS;
const GET_CLASS_URL = DEFAULT_SERVER + CLASS;
export const GET_PREVIEW_STUDENT_URL = DEFAULT_SERVER + PREVIEW_STUDENT;
const PRIVACY_CLASS_URL = DEFAULT_SERVER + CLASS;
const ELEARNING_CLASS_URL = DEFAULT_SERVER + CLASS;
const REFRESH_ELEARNING_COURSE_URL = DEFAULT_SERVER + "/api/v1/elearning";
const PERMISSION_URL = DEFAULT_SERVER + CLASS;

const buildClassFormData = (item: any): FormData => {
    var formData = new FormData();
    if (item.classBannerFile && item.classBannerFile[0]) {
        formData.append("classBanner", item.classBannerFile[0]);
    }
    const courses = item.course ?? [];
    for (let i = 0; i < courses.length; i++) {
        const classCourseBannerFile = courses[i].classCourseBannerFile;
        if (classCourseBannerFile && classCourseBannerFile[0]) {
            formData.append(`classCourseBanner_${i}`, classCourseBannerFile[0]);
        }
    }
    const classRequest = {
        ...item,
        classBannerFile: undefined,
        classBannerPreviewUrl: undefined,
        course: courses.map((c: any) => ({
            ...c,
            classCourseBannerFile: undefined,
            classCourseBannerPreviewUrl: undefined,
        })),
    };
    formData.append("classRequest", new Blob([JSON.stringify(classRequest)], { type: "application/json" }));
    return formData;
}

export class ClassAPI {

    public static list = async (projectId: number, partnerId: number,fromDate : Date | null, toDate: Date | null,page: number,limit: number,session:string|null,createById:number|null,markAsComplete:boolean|null,sort:string|null): Promise<any> => {
        return new Promise(function (resolve, reject) {
            var s=SEARCH_CLASS_URL;
            var queryParams: string[] = [];
            if(!isNaN(projectId)){
                queryParams.push(`project_id=${projectId}`)
            }
            if(!isNaN(partnerId)){
                queryParams.push(`partner_id=${partnerId}`)
            }
            if(fromDate!=null){
                queryParams.push(`from_date=`+ encodeURIComponent(Util.getLocalISOString(fromDate)))
            }
            if(toDate!=null){
                queryParams.push(`to_date=`+ encodeURIComponent(Util.getLocalISOString(toDate)))
            }
            if(session){
                queryParams.push(`session=${session}`)
            }
            if(createById){
                queryParams.push(`create_by=${createById}`)
            }
            if(markAsComplete!=null){
                queryParams.push(`mark_as_complete=${markAsComplete}`)
            }
            queryParams.push(`page=${page}`)
            queryParams.push(`limit=${limit}`)
            if(sort){
                queryParams.push(`sort=${sort}`)
            }
            
            apiClient.get(s+ '?' + queryParams.join('&'),
            {
                headers: {
                    "Accept": "application/json"
                }
            })
            .then((response) => {
                console.log("list class response : ", response);
                return resolve(response);
            }).catch(err => {
                console.log("list class error:", err);
                return reject(err); 
            })
        })
    }

    public static add = async (item:any): Promise<any> => {
        return new Promise(function (resolve, reject) {
            var s=ADD_CLASS_URL;
            apiClient.post(s,
                //payload
                buildClassFormData(item)
                ,{//options
                    headers: {
                        'Content-Type' : 'multipart/form-data; charset=utf-8',
                        'Accept': 'application/json'
                    }
                })
            .then((response) => {
                console.log("add class response : ", response);
                return resolve(response);
            }).catch(err => {
                console.log("add class error:", err);
                return reject(err);
            })
        })
    }

    public static update = async (id:number,item:any): Promise<any> => {
        return new Promise(function (resolve, reject) {
            var s=ADD_CLASS_URL+"/"+id;
            apiClient.patch(s,
                //payload
                buildClassFormData(item)
                ,{//options
                    headers: {
                        'Content-Type' : 'multipart/form-data; charset=utf-8',
                        'Accept': 'application/json'
                    }
                })
            .then((response) => {
                console.log("update class response : ", response);
                return resolve(response);
            }).catch(err => {
                console.log("update class error:", err);
                return reject(err);
            })
        })
    }

    public static markAsComplete = async (id:number): Promise<any> => {
        return new Promise(function (resolve, reject) {
            var s=ADD_CLASS_URL+"/mark-as-complete/"+id;
            apiClient.patch(s,
                {
                    headers: {
                        'Content-Type' : 'application/json'
                    }
                })
            .then((response) => {
                console.log("mark complete class response : ", response);
                return resolve(response);
            }).catch(err => {
                console.log("mark complete class error:", err);
                return reject(err); 
            })
        })
    }

    public static hasPermissionForClass = async (id: string): Promise<any> => {
        return new Promise(function (resolve, reject) {
            var s=PERMISSION_URL+"/"+id+"/permission";
            apiClient.get(s,
            {
                headers: {
                    "Accept": "application/json"
                }
            })
            .then((response) => {
                console.log("hasPermissionForClass response : ", response);
                return resolve(response);
            }).catch(err => {
                console.log("hasPermissionForClass error:", err);
                return reject(err); 
            })
        })
    }

    public static getCreateSessionBy = async (projectId?: number): Promise<any> => {
        return new Promise(function (resolve, reject) {
            var s=GET_CLASS_URL+"/create-session-by" + (projectId ? "?project_id="+projectId : "");
            apiClient.get(s,
            {
                headers: {
                    "Accept": "application/json"
                }
            })
            .then((response) => {
                return resolve(response);
            }).catch(err => {
                console.log("get create session by error:", err);
                return reject(err); 
            })
        })
    }
    
    public static getClass = async (id: string): Promise<any> => {
        return new Promise(function (resolve, reject) {
            var s=GET_CLASS_URL+"/"+id;
            apiClient.get(s,
            {
                headers: {
                    "Accept": "application/json"
                }
            })
            .then((response) => {
                console.log("get class response : ", response);
                return resolve(response);
            }).catch(err => {
                console.log("get class error:", err);
                return reject(err); 
            })
        })
    }

    public static validateClassCode = async (class_id: number, classCode: string): Promise<any> => {
        return new Promise(function (resolve, reject) {
            var s=GET_PREVIEW_STUDENT_URL+"/validate-code/" + class_id + "/" +classCode;
            apiClient.get(s,
            {
                headers: {
                    "Accept": "application/json",
                    "Authorization": null
                }
            })
            .then((response) => {
                console.log("get class response : ", response);
                return resolve(response);
            }).catch(err => {
                console.log("get class error:", err);
                return reject(err); 
            })
        })
    }

    public static getClassCourseWithName = async (id: string): Promise<any> => {
        return new Promise(function (resolve, reject) {
            var s=GET_CLASS_URL+"/course/"+id;
            apiClient.get(s,
            {
                headers: {
                    "Accept": "application/json"
                }
            })
            .then((response) => {
                console.log("get class course with name response : ", response);
                return resolve(response);
            }).catch(err => {
                console.log("get class course with name error:", err);
                return reject(err); 
            })
        })
    }

    public static deleteClass = async (id: string): Promise<any> => {
        return new Promise(function (resolve, reject) {
            var s=GET_CLASS_URL+"/"+id;
            apiClient.delete(s,
            {
                headers: {
                    "Accept": "application/json"
                }
            })
            .then((response) => {
                console.log("delete class response : ", response);
                return resolve(response);
            }).catch(err => {
                console.log("delete class error:", err);
                return reject(err); 
            })
        })
    }

    public static uploadPrivacy = async (classCourseId: string,file: FileList): Promise<any> => {
        return new Promise(function (resolve, reject) {
            var formData = new FormData();
            formData.append("file", file[0]);

            var s=PRIVACY_CLASS_URL+"/privacy/"+classCourseId;
            apiClient.post(s,formData
                ,{//options
                    headers: {
                        //"Content-Type": "multipart/form-data",
                        "Accept": "application/json"
                    }
                })
            .then((response) => {
                console.log("upload privacy response : ", response);
                return resolve(response);
            }).catch(err => {
                console.log("upload privacy error:", err);
                return reject(err); 
            })
        })
    }


    public static listELearning = async (classId: number, classCourseId: number,page: number,limit: number): Promise<any> => {
        return new Promise(function (resolve, reject) {
            var s=ELEARNING_CLASS_URL+"/elearning/"+classId+"/"+classCourseId+"?page="+page+"&limit="+limit; 
            console.log(s);
            apiClient.get(s,
            {
                headers: {
                    "Accept": "application/json"
                }
            })
            .then((response) => {
                console.log("list elearning response : ", response);
                return resolve(response);
            }).catch(err => {
                console.log("list elearning error:", err);
                return reject(err); 
            })
        })
    }

    public static importELearning = async (classId: number, classCourseId: number): Promise<any> => {
        return new Promise(function (resolve, reject) {
            var s=ELEARNING_CLASS_URL+"/elearning/"+classId+"/"+classCourseId; 
            apiClient.post(s,
                //payload
                {
                }
                ,{//options
                    headers: {
                        'Content-Type' : 'application/json'
                    }
                })
            .then((response) => {
                console.log("import elearning response : ", response);
                return resolve(response);
            }).catch(err => {
                console.log("import elearning error:", err);
                return reject(err); 
            })
        })
    }

    public static refreshElearningCourse = async (): Promise<any> => {
        return new Promise(function (resolve, reject) {
            var s=REFRESH_ELEARNING_COURSE_URL;
            apiClient.post(s,
                //payload
                {
                }
                ,{//options
                    headers: {
                        'Content-Type' : 'application/json'
                    }
                })
            .then((response) => {
                console.log("refresh elearning course response : ", response);
                return resolve(response);
            }).catch(err => {
                console.log("refresh elearning course error:", err);
                return reject(err); 
            })
        })
    }
}